import { coreActions } from '@sonar-software/sonar-core';
import { useAction } from '@hooks/useAction';
import { useFollowingIdReference } from './useFollowingIdReference';
import { useMemo } from 'react';

export function useUpdateFollowing(sonarObjectIds: number[] = []) {
	const following = useFollowingIdReference();
	const follow = useAction(coreActions.requestPostCoreFollow);
	const unfollow = useAction(coreActions.requestPostCoreUnfollow);

	const { followed, unfollowed } = useMemo(() => {
		const result = {
			followed: [],
			unfollowed: []
		} as {followed: number[], unfollowed: number[]};

		for (const sonarObjectId of sonarObjectIds) {
			if (following?.[ sonarObjectId ]) {
				result.followed.push(sonarObjectId);
			} else {
				result.unfollowed.push(sonarObjectId);
			}
		}

		return result;
	}, [ following, sonarObjectIds ]);

	return {
		follow: (ids?: number[]) => follow({ sonarObjectIds: ids ?? unfollowed }),
		followed,
		unfollow: (ids?: number[]) => unfollow({ sonarObjectIds: ids ?? followed }),
		unfollowed
	};
}
